import React from 'react'
import classNames from 'classnames'
import { getIntegrationDisplayName, type IntegrationServiceId } from '../../../../common/integrations'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'
import styles from './OnboardingIntegrationButton.module.scss'

export interface OnboardingIntegrationButtonProps {
  serviceId: IntegrationServiceId
  onClick: () => void
  className?: string
}

export const OnboardingIntegrationButton: React.FC<OnboardingIntegrationButtonProps> = ({ serviceId, onClick, className }) => (
  <button
    type='button'
    className={classNames(styles.btn, 'd-inline-flex flex-column align-items-center gap-2 bg-white rounded-4', className)}
    aria-label={`Connect ${getIntegrationDisplayName(serviceId)}`}
    onClick={onClick}
  >
    <IntegrationIcon serviceId={serviceId} width={20} height={20} />
    <span className={classNames(styles.name, 'fw-bold text-truncate mw-100')}>{getIntegrationDisplayName(serviceId)}</span>
  </button>
)
